import { components } from "./components/index";
import { events } from "./events/index";

const TaxCalculationSection = {
    events,
    components
}

export { TaxCalculationSection };